<template>
  <BreadCrumb PageTitle="Dashboard Supervision" />
  <SuperviseurDashboard />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import SuperviseurDashboard from "../../components/Superviseur/SuperviseurDashboard.vue";

export default defineComponent({
  name: "SuperviseurDashboardPage",
  components: {
    BreadCrumb,
    SuperviseurDashboard,
  },
});
</script>